import { EventEmitter, OnInit } from '@angular/core';
import { Task } from '../../shared/task';
var TaskOptionsComponent = /** @class */ (function () {
    function TaskOptionsComponent() {
        this.completed = new EventEmitter();
        this.declined = new EventEmitter();
        this.secondButtonCompleted = new EventEmitter();
    }
    TaskOptionsComponent.prototype.ngOnInit = function () { };
    TaskOptionsComponent.prototype.onComplete = function () {
        this.completed.emit();
    };
    TaskOptionsComponent.prototype.onSecondButtonComplete = function () {
        this.secondButtonCompleted.emit();
    };
    TaskOptionsComponent.prototype.onDecline = function () {
        this.declined.emit();
    };
    Object.defineProperty(TaskOptionsComponent.prototype, "completable", {
        get: function () {
            return this.task.isCompletable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskOptionsComponent.prototype, "hasSecondComplete", {
        get: function () {
            return this.task.type === 'consult_order';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskOptionsComponent.prototype, "completeButtonText", {
        get: function () {
            switch (this.task.type) {
                case 'vaccine_order':
                    return "I've Received The Vaccine";
                case 'consult_order':
                    return 'I Saw This Specialist';
                case 'procedure_order':
                    return "I've Done This Procedure";
                default:
                    return "I've Already Done This";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskOptionsComponent.prototype, "declineButtonText", {
        get: function () {
            switch (this.task.type) {
                case 'vaccine_order':
                    return 'Decline Vaccine';
                case 'consult_order':
                    return 'I No Longer Need A Visit';
                case 'procedure_order':
                    return 'I No Longer Need This';
                default:
                    return 'Decline';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskOptionsComponent.prototype, "secondCompleteButtonText", {
        get: function () {
            return 'I Went Elsewhere';
        },
        enumerable: true,
        configurable: true
    });
    return TaskOptionsComponent;
}());
export { TaskOptionsComponent };
